import { Component } from '@angular/core';
import { COLUMNS_HEADER_MATERIALS_ADMIN } from '../../core/constants/tables.constants';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProductsService } from '../../core/services/products.service';
import { PackagesService } from '../../core/services/packages.service';
import { ToastrService } from 'ngx-toastr';
import { MaterialsService } from '../../core/services/materials.service';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { CommonModule } from '@angular/common';
import { ValueStream } from '../../core/enums/general.enum';

@Component({
  selector: 'app-materials',
  standalone: true,
  imports: [FontAwesomeModule, FormsModule, ReactiveFormsModule, GenericTableComponent, CommonModule],
  templateUrl: './materials.component.html',
  styleUrl: './materials.component.scss'
})
export class MaterialsComponent {

  COLUMNS_HEADER = COLUMNS_HEADER_MATERIALS_ADMIN;
  valueStreamValues = Object.values(ValueStream);

  materials: any;
  materialsFiltered: any;
  products: any;
  packages: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;

  faSpinner = faSpinner;
  faMagnifyingGlass = faMagnifyingGlass;

  form: FormGroup = this.formBuilder.group({
    active: [false, Validators.required],
    fert: [, Validators.required],
    description: ['', Validators.required],
    weight: [, ],
    product: [],
    packaging: [],
    value_stream: ['', Validators.required],
  });


  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return (obj.fert?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.description?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.product_id?.toLowerCase().includes(this.filters.search.value) || obj.packaging_id?.toLowerCase().includes(this.filters.search.value))
      }
    },
    value_stream: {
      value: '',
      filter: (obj: any): boolean => obj.value_stream === this.filters.value_stream.value
    },
  };

  constructor(
    private productsSvc: ProductsService,
    private materialsSvc: MaterialsService,
    private formBuilder: FormBuilder,
    private packagesSvc: PackagesService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getPackages();
    this.getProducts();
    this.getMaterials();
    this.isLoading = false;
  }

  async onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getMaterials();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El producto ${this.form.value.fert} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El producto ${this.form.value.fert} ha sido actualizado correctamente`);
        }
        this.form.reset();

      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.materialsSvc.createMaterial(this.form.value).subscribe(responseAction);
      } else {
        this.materialsSvc.updateMaterial(this.form.value).subscribe(responseAction);
      }
    }
  }

  getMaterials() {
    let tmp: any[] = [];
    this.materialsSvc.getMaterials().subscribe((res: any) => {
      tmp = res;
      tmp.forEach((material: any) => {
        material.product_id = material.product.id;
        if (material.packaging) {
        material.packaging_id = material.packaging.id;
      }
      });
      this.materials = [...tmp];
      this.materialsFiltered = tmp;
      this.isLoading = false;
    });


  }

  getProducts() {
    this.productsSvc.getProducts().subscribe((res: any) => {
      this.products = res.products;
    });
  }

  getPackages() {
    this.packagesSvc.getPackages().subscribe((res: any) => {
      this.packages = res;
    });
  }

  openModal(item?: any) {
    if (item) {
      const selectedPackage = this.packages.find((pkg: any) => pkg.id === item.packaging_id);
      const selectedProduct = this.products.find((prod: any) => prod.id === item.product.id);
      this.form.patchValue({ ...item, packaging: selectedPackage, product: selectedProduct });
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }
  

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.materialsSvc.deleteMaterial(item.fert).subscribe({
      next: () => {
        this.getMaterials();
        this.isLoading = false;
        this.toastr.success(`El producto ${item.fert} ha sido eliminado correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }


  onFilter() {
    this.materialsFiltered = this.materials.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
          this.filters[key] = '';
      }
    }
  }

}
